import { getInitialLocale } from '@/@core/utils/getInitialLocale';
import { createStoreId } from '@/stores/createStoreId';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export type Locale = 'en' | 'de';

export const useWorkspaceStore = defineStore(
  createStoreId('workspace'),
  () => {
    const currentLocale = ref<Locale>(getInitialLocale());
    const isSidebarOpen = ref(true);
    const showPrivacyPolicyInfo = ref(true);
    const shouldSharepointBeConnected = ref(false);
    const isSharepointConnected = ref(false);

    const setAppLocale = (newLocale: Locale) => {
      currentLocale.value = newLocale;
    };

    const toggleSidebar = (isExpanded: boolean) => {
      isSidebarOpen.value = isExpanded;
    };

    return {
      setAppLocale,
      toggleSidebar,
      currentLocale,
      isSidebarOpen,
      showPrivacyPolicyInfo,
      shouldSharepointBeConnected,
      isSharepointConnected,
    };
  },
  {
    persist: true,
  }
);
